/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Edit_DescInputs */

const en_ui_studio_edit_desc = /** @type {(inputs: Ui_Studio_Edit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename the route or pick a track color.`)
};

const de_ui_studio_edit_desc = /** @type {(inputs: Ui_Studio_Edit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benenne die Route um oder wähle eine Farbe für den Track.`)
};

/**
* | output |
* | --- |
* | "Rename the route or pick a track color." |
*
* @param {Ui_Studio_Edit_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_edit_desc = /** @type {((inputs?: Ui_Studio_Edit_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Edit_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_edit_desc(inputs)
	return de_ui_studio_edit_desc(inputs)
});